import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationDeleteProjectArgs, BackendProject } from 'src/types/backend';

import { PROJECT_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation DeleteProject($projectId: Int!, $ifEmpty: Boolean) {
    deleteProject(projectId: $projectId, ifEmpty: $ifEmpty) {
      ...Project
    }
  }
  ${PROJECT_FRAGMENT}
`;

type Variables = BackendMutationDeleteProjectArgs;
type Result = BackendProject;

export const deleteProject = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
